import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  teams: [],
  team: {},
  team_id: '',
  listTeam: [],
  total: 0
};

export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_TEAMS:
        draft.teams = action.teams;
        break;
      case Types.GET_LIST_TEAM:
        draft.listTeam = action.payload.data;
        draft.total = action.payload.total;
        break;
      case Types.GET_TEAM_DETAIL:
        draft.team = action.payload;
        break;
      case Types.TEAM_DELETE:
        draft.team_id = action.payload;
        break;
      default:
        return state;
    }
  })

}

